import { apiGet } from "../helpers/request.helpers";
import { DraftLockResponse } from "./course-editor/useDraftLock";

export const showDraftLockStatusFn = async ({
  publicDraftUuid,
}: {
  publicDraftUuid: string;
}) => {
  const response = await apiGet("/locking/show-lock-status", {
    key: publicDraftUuid,
  });
  const lock: DraftLockResponse = response.Lock;
  return lock;
};
